/**
 * MoMent — LE N° DE DOSSIER BIO24 côté écran : un seul format, AAMMJJ/NNNN (RQ, 14/10/2026).
 *
 * MIROIR de `backend/src/moment/numero.ts` (le serveur reste l'AUTORITÉ ; ceci ne fait que prévenir à l'écran et guider la saisie).
 * `backend/tests/front-moment-numero.test.js` rejoue les deux sur le même corpus : ils ne peuvent pas diverger sans que le test casse.
 */
export const FORMAT_NUMERO = /^\d{6}\/\d{4}$/;

export function messageNumeroInvalide(numero: unknown, aujourdhui: Date = new Date()): string | null {
  const n = typeof numero === 'string' ? numero.trim() : '';
  if (!n) return 'Saisissez le n° de dossier BIO24 (AAMMJJ/NNNN).';
  if (!FORMAT_NUMERO.test(n)) return 'N° de dossier BIO24 : AAMMJJ/NNNN — la date de réception sur six chiffres, « / », puis quatre chiffres (ex. 261014/3350).';
  const aa = Number(n.slice(0, 2)); const mm = Number(n.slice(2, 4)); const jj = Number(n.slice(4, 6));
  const date = new Date(Date.UTC(2000 + aa, mm - 1, jj));
  if (date.getUTCFullYear() !== 2000 + aa || date.getUTCMonth() !== mm - 1 || date.getUTCDate() !== jj) return `La date du numéro « ${n.slice(0, 6)} » n'existe pas (AAMMJJ).`;
  const limite = Date.UTC(aujourdhui.getUTCFullYear(), aujourdhui.getUTCMonth(), aujourdhui.getUTCDate() + 1);
  if (date.getTime() > limite) return `La date du numéro « ${n.slice(0, 6)} » est dans le futur : c'est la date de réception du dossier.`;
  return null;
}

export const numeroValide = (numero: unknown, aujourdhui: Date = new Date()): boolean => messageNumeroInvalide(numero, aujourdhui) === null;

/** Le champ n'accepte QUE le format : des chiffres, la barre oblique s'insère après le sixième, dix chiffres au plus. */
export function formaterNumeroSaisi(brut: unknown): string {
  const chiffres = String(brut ?? '').replace(/\D/g, '').slice(0, 10);
  return chiffres.length > 6 ? `${chiffres.slice(0, 6)}/${chiffres.slice(6)}` : chiffres;
}
